module.exports = __webpack_public_path__ + "static/img/RPA-C-01-20.547a3e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RPA-C-01-20.jpg
// module id = 3THa
// module chunks = 9